export enum CategoryEnum {
    RACK = "Rack",
    PALLET = "Pallet"
}